import { BottomNavigation, Box, type BoxProps, Typography } from '@mui/material'

export const Footer = (props: BoxProps) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignContent="center"
      {...props}>
      <BottomNavigation sx={{ position: "absolute", height: 15 }}>
        <Box textAlign={'center'}>
          <Typography variant="caption">
            (c) Chubu Electric Power Miraiz Connect, Inc. All Rights Reserved.
          </Typography>
        </Box>
      </BottomNavigation>
    </Box>
  )
}
export const TerashiteFooter: React.FC = () => {
  return (
    <footer>
      <div className="footerwrapper_3">
        <div className="footerInner">
          <ul className="linkUl">
            <li>
              <a href="https://miraiz-connect.co.jp/" target="_blank" rel="noreferrer">
                運営会社
              </a>
            </li>
            <li>
              <a
                href="https://miraiz-connect.co.jp/privacy/website/"
                target="_blank" rel="noreferrer">
                プライバシーポリシー
              </a>
            </li>
          </ul>
          <div className="info_box">
            <p className="logo">
              <img src="/019e719d-361f-7331-bbf1-d4956cbc484b/common/img/logo.png" alt="中部電力ミライズコネクト" />
            </p>
            <div className="info">
              <p className="adr">愛知県名古屋市中区栄4丁目5番3号</p>
              <p className="ask"></p>
            </div>
          </div>
        </div>
      </div>
      <center>
        <p id="copy">
          (C)Chubu Electric Power Miraiz Connect, <br className="sp" />
          Inc.All Rights Reserved
        </p>
      </center>
    </footer>
  )
}